import { clsx } from 'clsx';
import { FC, ReactNode } from 'react';

import Box from '@o2/ui/Box';

import { useSubheaderUtilityClasses } from './subheaderClasses';

interface CustomContentProps {
  children: ReactNode;
}

const CustomContent: FC<CustomContentProps> = (props) => {
  const utilityClasses = useSubheaderUtilityClasses();

  return <Box order={4} flexBasis="100%" className={clsx(utilityClasses['custom-content'])} {...props} />;
};

CustomContent.displayName = 'Subheader.CustomContent';

export default CustomContent;
